import { Box, Button, IconButton, TextField, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import ChevronLeftRoundedIcon from '@mui/icons-material/ChevronLeftRounded';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import GlobalAutoComplete from '../../../../components/GlobalAutoComplete';
import { WD } from '../../../warningDashboard/warningTheme';
import { PRESETS, VIEWS } from '../utils/constants';
import Panel from './Panel';

const TOGGLE_SX = { px: 1.75, textTransform: 'none', fontWeight: 600, '&.Mui-selected': { bgcolor: WD.greenTint, color: WD.green } };

/** The project search, sized to sit in the bar beside the small date fields. */
const PROJECT_SX = {
  ml: { md: 'auto' },
  minWidth: 240,
  maxWidth: 320,
  flex: { xs: '1 1 100%', md: '0 1 280px' },
  '& .MuiOutlinedInput-root': { py: '1px' },
  '& .MuiInputLabel-root:not(.MuiInputLabel-shrink)': { transform: 'translate(14px, 9px) scale(1)' },
};

/**
 * The filter bar: List / Calendar, Day / Week / Month (list only), earlier / later, typed From → To (list only), Today, and a
 * searchable Project (the portal's GlobalAutoComplete).
 * `preset` is null while typed dates are in use, so no preset button shows as chosen.
 */
export default function WorkloadFilters({ view, preset, range, projectId, projectOptions, onView, onPreset, onStep, onDate, onToday, onProject }) {
  const calendar = view === 'calendar';

  return (
    <Panel sx={{ mt: 3, p: 1.5, display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 1.5 }}>
      <ToggleButtonGroup size="small" exclusive value={view} onChange={(_, key) => key && onView(key)} aria-label="View">
        {VIEWS.map((option) => (
          <ToggleButton key={option.key} value={option.key} sx={TOGGLE_SX}>{option.label}</ToggleButton>
        ))}
      </ToggleButtonGroup>
      {!calendar && (
        <ToggleButtonGroup size="small" exclusive value={preset} onChange={(_, key) => key && onPreset(key)} aria-label="Range">
          {PRESETS.map((option) => (
            <ToggleButton key={option.key} value={option.key} sx={TOGGLE_SX}>{option.label}</ToggleButton>
          ))}
        </ToggleButtonGroup>
      )}

      <Box display="flex" alignItems="center" gap={0.5}>
        <IconButton size="small" aria-label="Earlier" onClick={() => onStep(-1)} sx={{ border: `1px solid ${WD.border}` }}><ChevronLeftRoundedIcon fontSize="small" /></IconButton>
        <IconButton size="small" aria-label="Later" onClick={() => onStep(1)} sx={{ border: `1px solid ${WD.border}` }}><ChevronRightRoundedIcon fontSize="small" /></IconButton>
      </Box>
      <TextField type="date" size="small" label="From" value={range.from} onChange={(event) => onDate('from', event.target.value)} disabled={calendar} InputLabelProps={{ shrink: true }} />
      <Typography aria-hidden sx={{ color: WD.inkFaint }}>→</Typography>
      <TextField type="date" size="small" label="To" value={range.to} onChange={(event) => onDate('to', event.target.value)} disabled={calendar} InputLabelProps={{ shrink: true }} />
      <Button variant="outlined" size="small" onClick={onToday}>Today</Button>

      {/* Type to search; clearing it (×) goes back to all projects. */}
      <GlobalAutoComplete
        data={projectOptions}
        keyName={{ id: 'id', value: 'name' }}
        label="Project (all when empty)"
        selectValue={projectOptions.find((option) => option.id === projectId) || null}
        setSelectValue={(option) => onProject(option ? option.id : null)}
        sx={PROJECT_SX}
      />
    </Panel>
  );
}
